import GoogleAd from ".";

const BannerAd = () => {
  return (
    <GoogleAd
      adSlot="8032940247"
      adFormat="auto"
      adStyle={{ width: "100%", height: "90px" }}
    />
  );
};

export default BannerAd;
